export const REGISTER_USER_URL = '/api/register'
export const GET_CURRENCIES_LIST_URL = '/api/v1/configuration/get-currencies-list'
export const GET_COUNTRIES_LIST_URL = '/api/v1/configuration/get-countries-list'
